// Bundle dependencies

// import your modules here


// Bundle SEO module

import Plugin from './Plugin';

export default {

  version: () => {
    return NSContext.plugins.seo.version;
  }

};

// Initialize on document ready

// document.addEventListener("DOMContentLoaded", function () {
//   Plugin.init();
// });